import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["MobilePublicationsFilters"] */ "/vercel/path0/src/components/filters/mobilePublicationsFilters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventsList"] */ "/vercel/path0/src/components/list/eventsList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AgendaProvider"] */ "/vercel/path0/src/contexts/agenda.tsx");
